<app-page>
    <app-point-of-service [pointOfServiceId]="pointOfServiceId"></app-point-of-service>
</app-page>
